export interface PageSeoInterface {
	key: string,
	value: string
}

// Only what is worth writing by hand: everything else (the sharing title, description, Twitter values) follows from these
export const DefaultPageSeo: PageSeoInterface[] = [
	{key: 'title', value: ''},
	{key: 'description', value: ''},
	{key: 'og:image', value: ''}
];
